import React from 'react';
import { WideRoom, Corridor, Corner, Door } from './components';
import { COLORS } from './constants';
import './Maze.css';

const images = [
  require('./images/wall-blue.png'),
  require('./images/wall-cyan.png'),
  require('./images/wall-green.png'),
  require('./images/wall-grey.png'),
  require('./images/wall-red.png'),
  require('./images/wall-violet.png')
]

class Maze extends React.Component {

  state = {
    imageCount: 0
  }
  componentWillMount(){
    images.forEach(image => {
      const wallImage = new Image();
      wallImage.src = image
      wallImage.addEventListener('load', () => {
        console.log('loaded', wallImage.src)
        this.setState({
          imageCount: this.state.imageCount + 1
        })
      })
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    console.log('updated', nextState)
    if (nextState.imageCount === 6){
      if (!this.props.started){
        this.props.startTransitionOnImageLoad()
      }
      return true
    }
    return false
  }
  

  colors = ['blue', 'cyan', 'green', 'grey', 'red', 'violet']

  mazeVariation = [
    (
      <Door delay={0} isFirst>
          <Corridor delay={2}>
            <Corner direction="right" delay={4}>
              <Corridor delay={5}>
                <Corridor delay={7}>
                  <WideRoom delay={9}>
                    <Corner direction="left" delay={11}>
                      <Corridor delay={12} isLast onTransitionEnd={this.props.onTransitionEnd}>
                        <Door delay={14}/>
                      </Corridor>
                    </Corner>
                  </WideRoom>
                </Corridor>
              </Corridor>
            </Corner>
          </Corridor>
        </Door>
    ), 
    (
      <Door delay={0} isFirst color={this.props.color}>
        <WideRoom delay={2} color={this.props.color}>
          <Corner direction="left" delay={4} color={this.props.color}>
            <Corridor delay={5} color={this.props.color}>
              <Corridor delay={7} color={this.props.color}>
                <WideRoom delay={9} color={this.props.color}>
                  <Corner direction="right" delay={11} color={this.props.color}>
                    <Corridor delay={12} 
                      isLast color={this.props.color} 
                      onTransitionEnd={this.props.onTransitionEnd}
                    >
                      <Door delay={15}/>
                    </Corridor>
                  </Corner>
                </WideRoom>
              </Corridor>
            </Corridor>
          </Corner>
        </WideRoom>
      </Door>
    ),
    (
      <Door delay={0} isFirst>
          <Corridor delay={2}>
            <Corner direction="right" delay={4}>
              <Corridor delay={5}>
                <Corridor delay={7}>
                  <WideRoom delay={9}>
                    <Corner direction="left" delay={11}>
                      <Corridor delay={12} isLast onTransitionEnd={this.props.onTransitionEnd}>
                        <Door delay={14}/>
                      </Corridor>
                    </Corner>
                  </WideRoom>
                </Corridor>
              </Corridor>
            </Corner>
          </Corridor>
        </Door>
    ),
    (
      <Door delay={0} isFirst color={this.props.color}>
        <WideRoom delay={2} color={this.props.color}>
          <Corner direction="left" delay={4} color={this.props.color}>
            <Corridor delay={5} color={this.props.color}>
              <Corridor delay={7} color={this.props.color}>
                <WideRoom delay={9} color={this.props.color}>
                  <Corner direction="right" delay={11} color={this.props.color}>
                    <Corridor delay={12} 
                      isLast color={this.props.color} 
                      onTransitionEnd={this.props.onTransitionEnd}
                    >
                      <Door delay={15}/>
                    </Corridor>
                  </Corner>
                </WideRoom>
              </Corridor>
            </Corridor>
          </Corner>
        </WideRoom>
      </Door>
    ),
    (
      <Door delay={0} isFirst>
          <Corridor delay={2}>
            <Corner direction="right" delay={4}>
              <Corridor delay={5}>
                <Corridor delay={7}>
                  <WideRoom delay={9}>
                    <Corner direction="left" delay={11}>
                      <Corridor delay={12} isLast onTransitionEnd={this.props.onTransitionEnd}>
                        <Door delay={14}/>
                      </Corridor>
                    </Corner>
                  </WideRoom>
                </Corridor>
              </Corridor>
            </Corner>
          </Corridor>
        </Door>
    ),
    (
      <Door delay={0} isFirst color={this.props.color}>
        <WideRoom delay={2} color={this.props.color}>
          <Corner direction="left" delay={4} color={this.props.color}>
            <Corridor delay={5} color={this.props.color}>
              <Corridor delay={7} color={this.props.color}>
                <WideRoom delay={9} color={this.props.color}>
                  <Corner direction="right" delay={11} color={this.props.color}>
                    <Corridor delay={12} 
                      isLast color={this.props.color} 
                      onTransitionEnd={this.props.onTransitionEnd}
                    >
                      <Door delay={15}/>
                    </Corridor>
                  </Corner>
                </WideRoom>
              </Corridor>
            </Corridor>
          </Corner>
        </WideRoom>
      </Door>
    ),    
  ]

  getMazeVariation(variation){
    return this.mazeVariation[variation]
  }


  render() {
    return (
      <div className={`container ${this.props.start ? 'travel' : ''}`}>
        <div className={`center ${COLORS[this.props.variation]}`}>  
          {this.getMazeVariation(this.props.variation)}
        </div>
        { this.props.children }
      </div>
    )
  }
}

export default Maze;


// WEBPACK FOOTER //
// ./src/Maze.js